import React, { Component } from 'react';
import SubPageTopBar from '../../../Shared/SubPageTopBar/SubPageTopBar';
import { MEMORIAL } from '../../../../texts';
import * as api from '../../../../api';
import * as utils from '../../../../utils';
import { ASSETS_FOLDER } from '../../../../constants';
import './Memorial.css';

class Memorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    utils.scrollToTop();
    api
      .getMemorialData()
      .then(data => {
        this.setState({
          data,
        });
      })
      .catch(() => {
        // note - solve error state (not really needed in this case)
      });
  }

  render() {
    const names = this.state.data.map((name, index) => (
      <div className="person" key={encodeURIComponent(`${index}-${name}`)}>
        <div className="person-img-wrap">
          <img
            src={`${ASSETS_FOLDER}memorial/photo/${index}.jpg`}
            alt={`Foto - ${name[0]}`}
          />
        </div>

        <div className="name">{name[0]}</div>
        <div className="info">{name[1]}</div>
      </div>
    ));

    return (
      <div
        id="memorial"
        style={{
          background: `#151918 url(${`${ASSETS_FOLDER}memorial/bg-tile.jpg`}) repeat`,
        }}
      >
        <SubPageTopBar />
        <h1>{MEMORIAL.TITLE}</h1>
        <img
          id="memo-logo"
          src={`${ASSETS_FOLDER}memorial/deco-logo.png`}
          alt={MEMORIAL.ALT1}
        />
        <h2>{MEMORIAL.INFO}</h2>
        <div id="memo-persons">{names}</div>
        <p id="memo-note">
          Pokud máte chybějící fotografie zesnulých horníků, můžete nám je
          poslat na{' '}
          <a href="mailto:dukla61@ceskatelevize.cz">dukla61@ceskatelevize.cz</a>
        </p>
        <img
          id="memo-bottom-deco"
          src={`${ASSETS_FOLDER}memorial/deco-bottom.jpg`}
          alt={MEMORIAL.ALT2}
        />
      </div>
    );
  }
}

export default Memorial;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Memorial/Memorial.js